module.exports = __webpack_public_path__ + "static/media/Lima_disclaimer.b9d83bda.pdf";